import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '../../../domain/services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> {
    return this.checkAccess(state.url);
  }

  private checkAccess(
    requestedUrl: string,
  ): boolean | UrlTree | Observable<boolean | UrlTree> {
    const currentUser = this.authService.currentUserValue;
    if (currentUser) {
      if (currentUser.centerAdmin && currentUser.pendingLegalAcceptances?.length) {
        return this.router.parseUrl('/auth/legal-acceptance');
      }
      return true;
    }

    return this.authService.getUserByToken().pipe(
      map((user) => {
        if (user) {
          if (user.centerAdmin && user.pendingLegalAcceptances?.length) {
            return this.router.parseUrl('/auth/legal-acceptance');
          }
          return true;
        }

        this.authService.logout(requestedUrl);
        return false;
      }),
      catchError(() => {
        this.authService.logout(requestedUrl);
        return of(false);
      })
    );
  }
}
